import React from 'react';
import AuthToolbar from '../Layout/AuthToolbar'

const MyProfileContent = () => {
    const breadcumb = [
		{
			item: 'Home',
			path: '/'
		},
		{
			item: 'Account',
			path: ''
		},
        {
			item: 'Profile',
			path: ''
		}
    ]
    return (
        <React.Fragment>
            <AuthToolbar 
                title='Profile'
                breadcumb = {breadcumb}
            />
        </React.Fragment>
    );
}

export default MyProfileContent;